<template>
  <div class="edt">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">{{ pageTitle }} <v-chip
              small
              v-if="isModeUpdate"
            >{{ articleStatus }}</v-chip>
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <v-btn
          color="primary"
          class="mr-4"
          medium
          @click="onCancel"
          :disabled="form.$busy"
          text
          style="text-transform: none;"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save</v-btn>
      </div>
    </v-app-bar>
    <v-row class="px-4 py-4">
      <v-col
        lg="8"
        md="6"
        sm="12"
        xs="12"
      >
        <v-card
          outlined
          class="px-6 py-8"
        >
          <v-text-field
            outlined
            flat
            label="Title"
            required
            v-model="form.title"
            :error-messages="form.$getError('title')"
          />
          <v-text-field
            outlined
            flat
            label="Short Title"
            v-model="form.short_title"
            :error-messages="form.$getError('short_title')"
          />
          <v-text-field
            outlined
            flat
            label="Author Text"
            v-model="form.author"
            :error-messages="form.$getError('author')"
          />

          <author-selector-auto-complete
            :isChips="false"
            :isMultiple="true"
            :errorMessage="form.$getError('author')"
            v-model="form.authors"
            componentLabel="Author Selection"
          />

          <v-text-field
            outlined
            flat
            label="Caption/Label"
            hint="e.g.: HOT!, THRILLER"
            v-model="form.tag_text"
            :error-messages="form.$getError('tag_text')"
          />

          <!-- <sport-selector
            v-model="form.tag_type"
            :disabled="loadingTags"
            @change="tagTypeChanged"
            :error-messages="replace(head(form.$getError('tag_type')), 'tag type', 'sports')"
          /> -->

          <!-- <league-selector
            v-model="form.tag_name"
            :tagType="form.tag_type"
            @loadingState="state => this.loadingTags = state"
            @change="e => this.form.$clearError('tag_name')"
            :error-messages="replace(head(form.$getError('tag_name')), 'tag name', 'league')"
          /> -->

          <league-selector-auto-complete
            :isGetID="false"
            :isNotMultiple="false"
            v-model="form.tags"
            tagType="all"
            @loadingState="state => loadingTags = state"
          />

          <v-textarea
            outlined
            name="input-7-4"
            label="Summary"
            v-model="form.summarized_description"
            :error-messages="form.$getError('summarized_description')"
          ></v-textarea>

          <image-file-input-viewer
            v-model="form.thumbnail"
            :error-messages="form.$getError('thumbnail')"
          />

          <content-editor
            v-model="form.content_description"
            :error-messages="head(form.$getError('content_description'))"
          />

          <v-spacer></v-spacer>
          <v-btn
            small
            @click="previewArticleContent"
          >
            Preview Article Content
          </v-btn>
        </v-card>
      </v-col>
      <v-col
        lg="4"
        md="6"
        sm="12"
      >
        <v-card
          outlined
          class="px-6 pt-6 pb-3"
        >
          <v-checkbox
            flat
            label='Is Duplicate?'
            v-model="form.is_duplicate"
          ></v-checkbox>
        </v-card>

        <slug-generator
          class="mt-6"
          ref="slugGenerator"
          :base-string="form.title"
          v-model="slug"
          :error-messages="form.$getError('slug')"
        />

        <article-category
          class="mt-6"
          v-bind:articleCategory.sync="form.article_category"
        />

        <published-date-selector
          pageTitle="Prioritise Until"
          class="mt-6"
          v-model="form.prioritise_until"
        />

        <trending-option-manager
          class="mt-6"
          v-bind:trending.sync="form.is_trending"
          v-bind:states="form.us_states_id"
          @update:states="onStatesChange"
          v-bind:expiration-date.sync="form.trending_expiration_date"
          :expirationDateErrorMessages="form.$getError('trending_expiration_date')"
        />

        <published-date-selector
          class="mt-6"
          v-model="form.published_date"
        />

        <published-date-selector
          :isDisabled="true"
          pageTitle="Last Updated"
          class="mt-6"
          v-model="form.last_updated"
        />

        <article-matches
          v-bind:article_matches.sync="form.article_matches"
          class="mt-6"
        />

        <social-sharing-meta-tag
          v-bind:title.sync="form.social_summary_title"
          v-bind:description.sync="form.social_summary_description"
          v-bind:image.sync="form.social_thumbnail"
          class="mt-6"
        />

        <image-alt-text v-bind:imageAltText.sync="form.image_alt_text" />
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar.show"
      right
      bottom
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <template v-slot:action>
        <v-btn
          text
          @click="snackbar.show = false"
        >Close</v-btn>
      </template>
    </v-snackbar>
    <v-row justify="center">
      <v-dialog
        v-model="previewArticledialog"
        width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Article Content Preview</span>
          </v-card-title>
          <v-card-text v-html="articlePreviewContent">

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="previewArticledialog = false"
            >close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import Form from '@/utils/form'
import get from 'lodash/get'
import head from 'lodash/head'
import replace from 'lodash/replace'
import isNull from 'lodash/isNull'
import isEmpty from 'lodash/isEmpty'
import has from 'lodash/has'
import Article from '@/models/Article'
import dates from '@/utils/dates'
import LeagueSelector from '@/views/Home/Articles/shared/LeagueSelector'
import SportSelector from '@/views/Home/Articles/shared/SportSelector'
import SlugGenerator from '@/components/SlugGenerator'
import TrendingOptionManager from '@/views/Home/Articles/shared/TrendingOptionManager'
import PublishedDateSelector from '@/views/Home/Articles/shared/PublishedDateSelector'
import ContentEditor from '@/components/ContentEditor'
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import SocialSharingMetaTag from '@/components/SocialSharingMetaTag'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import map from 'lodash/map'
import slugify from 'slugify'
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
import hypometerWidgets from '@/utils/hypometerWidgets'
import groupBy from 'lodash/groupBy'
import cloneDeep from 'lodash/cloneDeep'
import uniqueId from 'lodash/uniqueId'
import merge from 'lodash/merge'
import ArticleMatches from '@/components/ArticleMatches'
import ImageAltText from '@/components/ImageAltText'
import LeagueSelectorAutoComplete from '@/views/Home/Articles/shared/LeagueSelectorAutoComplete'
import AuthorSelectorAutoComplete from '@/views/Home/Articles/shared/AuthorSelectorAutoComplete'
import MenuDatePicker from '@/components/MenuDatePicker.vue'
import ArticleCategory from '@/components/ArticleCategory.vue'

const WidgetDomain = process.env.APP_WIDGET_DOMAIN
  ? process.env.APP_WIDGET_DOMAIN
  : 'https://content-blocks-hosted-apihookup.azurewebsites.net'

const initialData = {
  title: null,
  short_title: null,
  slug: null,
  author: null,
  // tag_name: null,
  // tag_text: null,
  // tag_type: null,
  summarized_description: null,
  content_description: null,
  thumbnail: null,
  is_trending: false,
  trending_expiration_date: null,
  us_states_id: [],
  published_date: null,
  last_updated: null,
  social_summary_title: null,
  social_summary_description: null,
  social_thumbnail: null,
  matches: [],
  article_matches: [],
  is_duplicate: false,
  image_alt_text: null,
  tags: [],
  authors: []
}

/**
 * Create article is currently used in both creating and updating an article.
 * The request automatically identify if a post request or a put request is to
 * be used, it wil based on the id property if it exists.
 */
export default {
  head: {
    script: [
      { type: 'text/javascript', src: 'https://platform.twitter.com/widgets.js', charset: 'utf-8' },
      { type: 'text/javascript', src: WidgetDomain + '/static/js/external-game-bar-loader.js' },
      {
        type: 'text/javascript',
        src: WidgetDomain + '/static/js/external-match-page-loader.js',
        defer: true
      },

      { type: 'text/javascript', src: WidgetDomain + '/static/js/external-value-bets-loader.js' },

      {
        type: 'text/javascript',
        src:
          WidgetDomain + '/static/js/external-pre-match-predictions-loader.js'
      },
      { type: 'text/javascript', src: WidgetDomain + '/static/js/external-match-page-header-loader.js' },
      { type: 'text/javascript', src: WidgetDomain + '/static/js/external-match-best-bet-loader.js' },
      { type: 'text/javascript', src: WidgetDomain + '/static/js/external-live-dashboard-loader.js' },
      { type: 'text/javascript', src: WidgetDomain + '/static/js/external-futures-loader.js' },
      { type: 'text/javascript', src: WidgetDomain + '/static/js/external-futures-mini-loader.js' }
    ]
  },
  props: {
    article: {
      type: [Article, Object],
      default () {
        return {}
      }
    },
    pageTitle: {
      type: String,
      default: 'Create New Article'
    },
    redirectCancelTo: {
      type: [String, Object],
      default () {
        return {
          name: 'articles'
        }
      }
    },
    redirectSaveTo: {
      type: [String, Object],
      default () {
        return {
          name: 'articles'
        }
      }
    }
  },
  components: {
    AppBarNavIcon,
    LeagueSelector,
    SportSelector,
    SlugGenerator,
    TrendingOptionManager,
    PublishedDateSelector,
    ContentEditor,
    ImageFileInputViewer,
    SocialSharingMetaTag,
    ArticleMatches,
    ImageAltText,
    LeagueSelectorAutoComplete,
    AuthorSelectorAutoComplete,
    MenuDatePicker,
    ArticleCategory
  },
  data () {
    return {
      hypometerWidgets,
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      loadingTags: false,
      form: new Form({
        ...initialData
      }),
      previewArticledialog: false,
      articlePreviewContent: ''
    }
  },
  computed: {
    slug: {
      get () {
        if (this.form.slug && this.form.slug.trim() !== '') {
          return this.form.slug
        }

        if (this.form.title) {
          return slugify(this.form.title, {
            remove: /[*+~.()'"!:@]/g,
            lower: true,
            strict: true
          })
        }

        return null
      },
      set (v) {
        this.form.slug = v
      }
    },
    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    },
    articleStatus () {
      const publishedDate = get(this.form.$originalData, 'published_date', null)
      if (publishedDate !== null) {
        if (dayjs(publishedDate).local().isAfter(dayjs())) {
          return 'Scheduled'
        } else {
          return 'Published'
        }
      }

      return 'Draft'
    }
  },
  watch: {
    article: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            ...initialData,
            ...val,
            us_states_id: map(val.states, 'id'),
            // tag_type: get(val, 'tags.0.type', '').toLowerCase(),
            // tag_name: map(val.tags, 'name'),
            tags: map(val.tags, 'name'),
            social_thumbnail: val.socialThumbnail,
            authors: map(val.authors, 'id')
          })

          if (val.thumbnail) {
            this.form.image_alt_text = val.thumbnail.custom_properties.alt_text
          }

          if (!this.form.slug) {
            this.$nextTick(() => this.$refs['slugGenerator'].generate())
          }

          if (has(this.form, 'prioritise_until') && !isNull(this.form.prioritise_until)) {
            this.form.prioritise_until = dayjs(new Date(this.form.prioritise_until + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
          }
        }
      }
    },
    previewArticledialog (val) {
      if (val === false) {
        this.closePreviewArticleDialog()
      }
    }
  },
  mounted () {
    document.body.scrollTop = 0 // For Safari
    document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

    if (!this.form.id) this.form.article_matches = []
  },
  methods: {
    head,
    replace,
    ...mapActions({
      updateArticleThumbnail: 'article/updateArticleThumbnail',
      updateSocialThumbnail: 'article/updateSocialThumbnail'
    }),
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    onStatesChange (value) {
      if (isEmpty(value)) {
        this.$set(this.form, 'us_states_id', [])
      } else {
        this.$set(this.form, 'us_states_id', value)
      }
    },
    tagTypeChanged () {
      this.$set(this.form, 'tag_name', [])
      this.form.$clearError('tag_name')
      this.form.$clearError('tag_type')
    },
    onCancel () {
      this.$router.replace(this.redirectCancelTo)
    },
    async onSave () {
      try {
        this.checkArticlePromo()

        this.form.$busy = true
        this.form.$clearErrors()
        const data = this.form.$data()
        data.slug = data.slug ? data.slug : this.slug

        // Convert to utc and set the format to the one the api accepts
        if (has(data, 'published_date') && !isNull(data.published_date)) {
          data.published_date = dates.localDateToUTC(data.published_date).format('YYYY-MM-DD HH:mm:ss')
        }

        if (has(data, 'last_updated') && !isNull(data.last_updated)) {
          data.last_updated = dates.localDateToUTC(data.last_updated).format('YYYY-MM-DD HH:mm:ss')
        }

        if (has(data, 'prioritise_until') && !isNull(data.prioritise_until)) {
          data.prioritise_until = dates.localDateToUTC(data.prioritise_until).format('YYYY-MM-DD HH:mm:ss')
        }

        // clean matches
        if (data.article_matches) {
          data.matches = []
          data.article_matches.map((match, i) => {
            if (match.match_id) data.matches.push(match.match_id)
          })
        }
        if (data.matches.length === 0) {
          delete data.matches
        }

        const article = new Article(data)
        await article.save()
        await this.executeOnUpdate()
        this.$router.push(this.redirectSaveTo)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    checkArticlePromo () {
      // remove old slug attribs
      var slugReg = new RegExp('data-widget="slug"', 'g')
      if (this.form.content_description) {
        this.form.content_description = this.form.content_description.replace(slugReg, '')

        var reg = new RegExp('href="' + process.env.VUE_APP_WEB_URL + '/go/', 'g')
        let replaceW = 'data-widget="slug" href="' + process.env.VUE_APP_WEB_URL + '/go/'
        this.form.content_description = this.form.content_description.replace(reg, replaceW)
      }
    },

    async executeOnUpdate () {
      if (!this.isModeUpdate) return

      const data = this.form.$data()
      /**
       * If thumbnail was replaced with a File.
       * user was probably trying to replace the
       * thumbnail.
       *
       * @todo This should be in 1 request api and not multiple request
       */
      if (data.thumbnail instanceof File) {
        const thumbnailFormData = new FormData()
        thumbnailFormData.append('thumbnail', data.thumbnail)
        thumbnailFormData.append('id', data.id)
        await this.updateArticleThumbnail(thumbnailFormData)
      }

      /**
       * If social_thumbnail was replaced with a File.
       * user was probably trying to replace the
       * social_thumbnail.
       *
       * @todo This should be in 1 request api and not multiple request
       */
      if (data.social_thumbnail instanceof File) {
        const socialThumbnailFormData = new FormData()
        socialThumbnailFormData.append('social_thumbnail', data.social_thumbnail)
        socialThumbnailFormData.append('id', data.id)
        await this.updateSocialThumbnail(socialThumbnailFormData)
      }
    },
    loadWidget () {
      /**
       * Group by widget type
       */
      const widgets = groupBy(
        document.querySelectorAll('[data-widget]'),
        (item) => item.getAttribute('data-widget')
      )

      /**
       * We will mapped the default configuration and function
       * so that we don't have to do some conditional statements
       * */
      const defaultWidgets = {

        'external-pre-match-predictions': {
          config: this.hypometerWidgets.centrePreMatch,
          function: loadSiPreMatchPredictions
        },
        'external-match-page-header': {
          config: this.hypometerWidgets.centreHeading,
          function: loadSiMatchPageHeader
        },
        'external-match-best-bet': {
          config: this.hypometerWidgets.centreBestBet,
          function: loadSiMatchBestBet
        },
        'external-futures-mini': {
          config: this.hypometerWidgets.futuresMini,
          function: loadSiFuturesMini
        }
      }

      Object.keys(widgets).forEach((key) => {
        /**
         * Get all the configuration and add a unique id on each widget
         */
        const configs = map(get(widgets, key), (widget) => {
          const id = uniqueId(
            `si-${widget.getAttribute('data-widget')}-widget-`
          )

          const config = JSON.parse(widget.getAttribute('data-widget-append'))
          config.targetElementID = id
          widget.setAttribute('id', id)
          widget.classList.add('hypometer-widget')

          /**
           * Map the default configurations.
           *
           * Let's do some cloning since merge mutate objects and we don't want that.
           */
          return merge(
            {},
            cloneDeep(get(defaultWidgets, `${key}.config`)),
            cloneDeep(config)

          )
        })
        /**
         * Call the function to load the configurations
         */
        if (has(defaultWidgets, `${key}.function`)) {
          get(defaultWidgets, `${key}.function`)(configs)
        } else {
          console.log(`No registered function for: ${key}`)
        }
      })
    },

    previewArticleContent () {
      this.previewArticledialog = true
      this.articlePreviewContent = this.form.content_description
      setTimeout(() => this.loadWidget(), 500)
      twttr.widgets.load()
    },

    closePreviewArticleDialog () {
      this.articlePreviewContent = ''
    }

  }
}
</script>
